import { TranslationKey } from 'providers/i18n/types';

export const enum NotificationTypes {
  Report = 'report_export',
  OrderAdjustment = 'order_adjustment',
  CommissionRecalculationTasks = 'recalculate_commission_task',
  Reconciliation = 'order_status_reconciliation',
}

export const enum NotificationStatuses {
  Done = 'done',
  Failure = 'failed',
  Downloaded = 'downloaded',
}

export const NOTIFICATION_STATUSES_KEYS: Record<NotificationStatuses, TranslationKey> = {
  [NotificationStatuses.Done]: 'app.notificationPopper.notificationStatuses.done',
  [NotificationStatuses.Downloaded]: 'app.notificationPopper.notificationStatuses.downloaded',
  [NotificationStatuses.Failure]: 'app.notificationPopper.notificationStatuses.failure',
};

export const NOTIFICATIONS_REFETCH_INTERVAL = 10000;
